import { provideRouter, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from '../app.routes';

export const routerProviders = [
  provideRouter(
    appRoutes,
    withHashLocation(),
    withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
  ),
];
